import { typeProfil } from 'handimap-react-lib/enum/typeProfil';

export const graphByProfile = profil => {
  switch (profil) {
    case (typeProfil.TYPE_2):
      return 'cnig_visually_impaired_user';
    case (typeProfil.TYPE_3):
      return 'cnig_wheelchair_user';
    default:
      return 'basic_pedestrian';
  }
};